'use strict';

var _ = require('lodash');
var EntryLevelBenchmarkDataTransformerService = function EntryLevelBenchmarkDataTransformerService(faresOptimizerConstants, faresOptimizerAnalysisDataUtilsService) {
  function buildEntryLevelBenchmarkData(recommendationLadder, market, setOfAllSelectedCompetitorKeys) {
    setIsSelectedToMappedCompetitors(recommendationLadder);
    return buildAtpcoEntryLevelBenchmarkData(recommendationLadder, market, setOfAllSelectedCompetitorKeys);
  }
  function setIsSelectedToMappedCompetitors(recommendationLadder) {
    _.forEach(recommendationLadder.fareRecommendationList, function (fare) {
      if (fare.selectedCompetitorKey !== undefined) {
        var comp = _.find(recommendationLadder.competitorFares, function (compFare) {
          if (compFare.competitorKey !== undefined && compFare.competitorKey === fare.selectedCompetitorKey && compFare.hostRbd === fare.rbd) {
            return compFare;
          }
        });
        if (comp !== undefined) {
          comp.isSelected = true;
        }
      }
    });
  }
  function buildAtpcoEntryLevelBenchmarkData(recommendationLadder, market, setOfAllSelectedCompetitorKeys) {
    return _.transform(recommendationLadder.competitorFares, function (entryLevelBenchmarkData, competitorFare) {
      var fareBrandInfo = faresOptimizerAnalysisDataUtilsService.getFareBrandInfo(competitorFare.carrier, competitorFare.fareBrand);
      entryLevelBenchmarkData.push({
        market: market,
        carrier: competitorFare.carrier,
        compMarket: competitorFare.origin + '-' + competitorFare.destination,
        origin: competitorFare.origin,
        destination: competitorFare.destination,
        rbd: competitorFare.rbd,
        fbc: competitorFare.fareBasisCode,
        tariffCode: competitorFare.tariffCode,
        routingNumber: competitorFare.routingNumber,
        seasonIndicator: competitorFare.seasonIndicator,
        daysOfWeek: competitorFare.outboundDaysOfWeek,
        footnote: competitorFare.footnote,
        minStay: competitorFare.minStay,
        maxStay: competitorFare.maxStay,
        fareSource: _.isNil(competitorFare.fareSource) ? faresOptimizerConstants.FARE_SOURCE.ATPCO : competitorFare.fareSource,
        ap: competitorFare.advancePurchase,
        currencyCode: competitorFare.currencyCode,
        baseFare: competitorFare.baseFare,
        totalFare: competitorFare.totalFare,
        nbrOfSeasons: competitorFare.outboundSeasons !== undefined ? competitorFare.outboundSeasons.length : 0,
        nbrOfBlackouts: competitorFare.outboundBlackouts !== undefined ? competitorFare.outboundBlackouts.length : 0,
        matchPercentage: competitorFare.matchPercentage,
        yq: competitorFare.yq,
        yr: competitorFare.yr,
        q: competitorFare.q,
        airportTax: competitorFare.other,
        variable: competitorFare.variable,
        qMisc: competitorFare.qmisc,
        travelFromDate: competitorFare.travelFromDate,
        travelToDate: competitorFare.travelToDate,
        travelCompleteDate: competitorFare.travelCompleteDate,
        firstTicketDate: competitorFare.firstTicketDate,
        lastTicketDate: competitorFare.lastTicketDate,
        effectiveDate: competitorFare.effectiveDate,
        discontinueDate: competitorFare.discontinueDate,
        outboundSeasons: competitorFare.outboundSeasons,
        outboundBlackouts: competitorFare.outboundBlackouts,
        inboundSeasons: competitorFare.inboundSeasons,
        inboundBlackouts: competitorFare.inboundBlackouts,
        reservationDates: competitorFare.reservationDates,
        ticketingDates: competitorFare.ticketingDates,
        inboundTravelDates: competitorFare.inboundTravelDates,
        outboundTravelDates: competitorFare.outboundTravelDates,
        selected: competitorFare.isSelected,
        isSelectedCompetitor: competitorFare.isSelected,
        benchmarkFareComponent: competitorFare.benchmarkFareComponent,
        isActive: competitorFare.isActive,
        active: competitorFare.isActive,
        tripType: faresOptimizerConstants.FARE_TYPES[competitorFare.tripType],
        fareBrand: fareBrandInfo.fareBrand,
        fareBrandName: fareBrandInfo.fareBrandName,
        hostRbd: competitorFare.hostRbd,
        inventoryAssignmentMethod: recommendationLadder.inventoryAssignmentMethod,
        useForLadderGenerationInd: getUseForLadderGenerationIndicator(recommendationLadder, competitorFare.hostRbd),
        previousState: competitorFare.isSelected,
        competitorKey: competitorFare.competitorKey,
        isShowCheckedAndDisabled: setOfAllSelectedCompetitorKeys && setOfAllSelectedCompetitorKeys.has(competitorFare.competitorKey)
      });
      return entryLevelBenchmarkData;
    }, []);
  }
  function getUseForLadderGenerationIndicator(recommendationLadder, hostMappedRbd) {
    var recommendation = _.find(recommendationLadder.fareRecommendationList, {
      'rbd': hostMappedRbd
    });
    return _.isNil(recommendation) || getLadderGenerationInd(recommendation);
  }
  function getLadderGenerationInd(recommendation) {
    return recommendation.useForLadderGenerationInd === undefined ? false : recommendation.useForLadderGenerationInd;
  }
  return {
    buildEntryLevelBenchmarkData: buildEntryLevelBenchmarkData
  };
};
EntryLevelBenchmarkDataTransformerService.$inject = ['FaresOptimizerConstants', 'FaresOptimizerAnalysisDataUtilsService'];
module.exports = EntryLevelBenchmarkDataTransformerService;